// import { FormGroup, FormControlLabel, Checkbox, FormHelperText, FormLabel } from "@mui/material";
// import { useEffect, useState } from "react";
// import paymentdashboardservice from "../../../services/paymentdashboardservice";
// import { Controller } from "react-hook-form";

// function SelectedPlatforms({ getValues, setValue, errors, control }) {
//   const [platforms, setPlatforms] = useState([]);

//   const Init = async () => {
//     let platforms = await paymentdashboardservice.FetchPlatforms();
//     platforms = platforms.map((obj) => ({ ...obj, label: obj.name }));
//     setPlatforms(platforms);
//   };

//   useEffect(() => {
//     Init();
//   }, []);

//   return (
//     <Controller
//       name="platforms"
//       control={control}
//       defaultValue={[]}
//       render={({ field }) => (
//         <FormGroup>
//           <FormLabel>Platforms*</FormLabel>
//           {platforms.map((platform) => (
//             <FormControlLabel
//               key={platform._id}
//               control={
//                 <Checkbox
//                   checked={(field.value || []).includes(platform._id)}
//                   onChange={(e) => {
//                     const checked = e.target.checked;
//                     const updatedValue = checked
//                       ? [...(field.value || []), platform._id]
//                       : (field.value || []).filter((id) => id !== platform._id);
//                     field.onChange(updatedValue);
//                   }}
//                 />
//               }
//               label={platform.label}
//             />
//           ))}
//           {errors.platforms && (
//             <FormHelperText error>{errors.platforms.message}</FormHelperText>
//           )}
//         </FormGroup>
//       )}
//     />
//   );
// }

// export default SelectedPlatforms;

import { FormGroup, FormControlLabel, Checkbox, FormHelperText, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import paymentdashboardservice from "../../../services/paymentdashboardservice";
import { Controller } from "react-hook-form";

// Import Box if not already imported
import { Box } from "@mui/material";

function SelectedPlatforms({ getValues, setValue, errors, control }) {
  const [platforms, setPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);

  const Init = async () => {
    try {
      setLoading(true);
      let platforms = await paymentdashboardservice.FetchPlatforms();
      platforms = platforms.map((obj) => ({ ...obj, label: obj.name }));
      setPlatforms(platforms);
    } catch (error) {
      console.error("Error fetching platforms:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Init();
  }, []);

  if (loading) {
    return <div>Loading platforms...</div>;
  }

  return (
    <Controller
      name="platform" // IMPORTANT: Must match the field name in schema
      control={control}
      defaultValue={[]}
      render={({ field }) => (
        <FormGroup>
          <FormLabel sx={{ fontWeight: 'bold', mb: 1 }}>
            {/* Platforms* <span style={{ color: 'red' }}>(Select at least one)</span> */}
          </FormLabel>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {platforms.map((platform) => (
              <FormControlLabel
                key={platform._id}
                control={
                  <Checkbox
                    checked={(field.value || []).includes(platform._id)}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      const updatedValue = checked
                        ? [...(field.value || []), platform._id]
                        : (field.value || []).filter((id) => id !== platform._id);
                      field.onChange(updatedValue);
                      // Optional: trigger validation on change
                      if (setValue) {
                        setValue("platform", updatedValue, { shouldValidate: true });
                      }
                    }}
                  />
                }
                label={platform.label}
              />
            ))}
          </Box>
          {errors.platform && (
            <FormHelperText error sx={{ ml: 0 }}>
              {errors.platform.message}
            </FormHelperText>
          )}
          {!errors.platform && (field.value || []).length === 0 && (
            <FormHelperText sx={{ ml: 0 }}>
              Please select at least one platform
            </FormHelperText>
          )}
        </FormGroup>
      )}
    />
  );
}


export default SelectedPlatforms;